import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const FleetUsageUpdate2007 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення 20.07</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Головна зміна — тижневе підтвердження користування автопарковими авто водіями, окрема сторінка
        логування для партнера та алерти при відхиленнях. Також покращено історію водіїв на авто, завантаження
        фактур водієм, таблицю додаткових коштів і статистику за тиждень.
      </p>

      <Alert variant="warning">
        <b>Перед деплоєм на прод:</b> виконати SQL-міграцію{" "}
        <code>server/migrations/create_vehicle_usage_logs.sql</code> і перезапустити сервер. Без таблиці{" "}
        <code>vehicle_usage_logs</code> підтвердження авто не працюватиме.
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Логування користування авто (головне)</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Якщо до водія (<code>role = user</code>) <b>прикріплене авто</b>, у будь-який день поточного
                тижня система запитує про <b>минулий</b> тиждень (Пн–Нд, тиждень у форматі{" "}
                <code>YYYYWW</code>, часовий пояс <b>Europe/Warsaw</b>).
              </li>
              <li>
                Запит іде <b>по кожному авто</b>, яке було закріплене за водієм у тому тижні (з урахуванням
                історії водіїв на авто).
              </li>
              <li>
                Поки відповіді немає — поверх усіх сторінок показується блокуюче вікно: водій не може
                користуватись сайтом, доки не підтвердить або не відхилить.
              </li>
              <li>
                Якщо водій кілька тижнів не заходив — питаємо лише про <b>останній минулий</b> тиждень, без
                накопичення старих тижнів.
              </li>
              <li>
                <b>Так</b> — запис підтвердження (зелений у адмінці). <b>Ні</b> — водій вказує номери авто, якими
                користувався, і дати «від» / «до»; це зберігається як текстова відповідь (червоний запис).
              </li>
              <li>
                Нова сторінка в автопарку: <b>«Логування авто»</b> (
                <code>/admin/fleet/usage-logs</code>) — список підтверджень / відхилень / без відповіді /
                опрацьованих, фільтр по тижню й статусу, пошук по водію/авто. Червоні записи зверху.
              </li>
              <li>
                Червоні (відхилені) адмін може позначити як <b>опрацьовано</b> з опційним коментарем — після
                цього алерт зникає.
              </li>
              <li>
                Якщо є неопрацьовані червоні записи — червоне повідомлення з посиланням на сторінку логування:
                на головній після «Статистика за тиждень» і на сторінці автопарку.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як користуватись — водій</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>Увійти в акаунт (роль водія), якщо є прикріплене авто.</li>
              <li>
                З’явиться вікно з датами минулого тижня і списком авто. По кожному авто обрати{" "}
                <Badge bg="success">Так</Badge> або <Badge bg="danger">Ні</Badge>.
              </li>
              <li>
                При «Ні» заповнити номери авто та період (дата від / до), потім натиснути «Надіслати відповідь».
              </li>
              <li>Після відповіді по всіх авто вікно зникає — сайт знову доступний.</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Як користуватись — партнер / адмін</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Меню <b>«Автопарк» → «Логування авто»</b> (також кнопка на списку авто).
              </li>
              <li>Обрати тиждень — побачити підтверджені (зелені), відхилені (червоні), без відповіді (жовті), опрацьовані.</li>
              <li>
                Для червоного рядка — кнопка «Опрацьовано», за потреби додати коментар адміна.
              </li>
              <li>
                Стежити за алертом на головній і на <code>/admin/fleet</code>, поки є неопрацьовані відхилення.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Автопарк — історія водіїв на авто</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Поточний водій визначається з <b>відкритого</b> запису історії (без дати «до»), а не лише з
                поля <code>driver_id</code> — менше розсинхрону.
              </li>
              <li>
                При додаванні / видаленні запису історії форма авто одразу підтягує актуальний список і
                поточного водія з відповіді сервера.
              </li>
              <li>
                Зміна водія коректніше закриває попередній відкритий запис історії й відкриває новий.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Завантаження фактури водієм</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Сума VAT приймає зручні формати: кома або крапка, пробіли як роздільник тисяч (наприклад{" "}
                <code>1 234,56</code>).
              </li>
              <li>Приймаються лише файли-зображення; ліміт розміру як і раніше — 5 МБ.</li>
              <li>Чіткіші повідомлення про помилки та детальніші логи на сервері при невдалому завантаженні.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>6. Інші дрібні покращення</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <b>Додаткові кошти:</b> фіксовані ширини колонок таблиці, щоб рядки менше «стрибали» при довгих
                значеннях.
              </li>
              <li>
                <b>Статистика за тиждень:</b> дані підвантажуються одразу після вибору тижня, окрема кнопка
                «Завантажити» більше не потрібна.
              </li>
              <li>
                У деталях звіту водія прибрано додаткову підказку біля рядка salary (залишилась лише сума).
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>7. Технічно (для деплою)</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Нова таблиця БД: <code>vehicle_usage_logs</code> (міграція{" "}
                <code>create_vehicle_usage_logs.sql</code>).
              </li>
              <li>
                Новий API: <code>/api/vehicle-usage-logs</code> (pending / answer для водія; список, alerts,
                process для адміна).
              </li>
              <li>
                Нові сторінки/компоненти: блокуюче вікно водія, алерт адміна, сторінка логування авто.
              </li>
              <li>Переклади: ua / pl / en / ru для нових текстів автопарку.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default FleetUsageUpdate2007;
